//* 可视化图形
import { GeneticInformation } from "@cya/genetic-information";
//* 组件属性
import type { ModuleProps } from "../index";
import { useOptions } from "./options";

export const useComposable = (define: ModuleProps) => {
    //* 配置项
    const options = useOptions(define);

    //* 静态数据
    const vars: { canvas?: GeneticInformation } = {};
    //* 节点
    const nodes = {
        canvas: useTemplateRef<HTMLDivElement>("canvas"),
    };

    //* 函数列表
    const methods = {
        init: () => {
            vars.canvas?.destroy();
            if (nodes.canvas.value) {
                vars.canvas = new GeneticInformation(nodes.canvas.value, {
                    gene_click_handler: (data) => open(routerResolve({ name: "Gene", params: { id: data.id } }).href, "_blank"),
                    language: useI18n().locale.value,
                    resize: true,
                    data: {
                        name: define.origin.symbol,
                        chromosome: define.origin.chromosome,
                        attachments: define.origin.attachments,
                    },
                });
            }
        },
    };

    return { vars, nodes, options, methods };
};
